<template>
  <div class="computer-time">
    <el-dialog
      title="电脑时间不准确"
      :visible.sync="timeDialogVisible"
      width="500px"
      :before-close="handleClose"
      center
    >
      <i class="el-icon-warning"></i>
      <div class="dialog-content">
        <p>温馨提示：</p>
        <p>当前电脑系统的时间不准确，请同步更新时间，避免影响使用。</p>
        <a
          href="https://wwskglt5oj.feishu.cn/docx/NX4edoRy9o4bywxpN8occVEzn4p"
          target="_blank"
          style="color: #409eff"
        >点击查看详细教程</a>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog, Button } from 'element-ui'
export default {
  components: {
    ElButton: Button,
    ElDialog: Dialog,
  },
  props: {
    timeDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:timeDialogVisible', false)
    }
  }
}
</script>

<style scoped lang="less">
.computer-time {
  /deep/.el-dialog__body {
    padding: 25px 45px 30px;
  }
  /deep/.el-dialog__footer {
    padding-bottom: 30px;
  }
  .el-icon-warning {
    position: absolute;
    top: 19px;
    left: 33%;
    transform: translateX(-33%);
    width: 25px;
    height: 25px;
    color: #e6a23c;
    font-size: 25px;
  }
  .dialog-content {
    a {
      display: inline-block;
      width: 100%;
      text-align: right;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>